<!-- Button -->
<button mat-icon-button type="button" (click)="languagesPanel.toggle($event)">
  <ng-container
    *ngTemplateOutlet="flagImage; context: { $implicit: activeLang }"
  ></ng-container>
</button>

<p-overlayPanel #languagesPanel [showCloseIcon]="false" appendTo="body">
  <div class="flex flex-col min-w-40">
    <button
      type="button"
      class="flex items-center px-3 py-2 text-left transition-colors hover:bg-gray-100"
      *ngFor="let lang of $any(availableLangs); trackBy: trackByFn"
      (click)="setActiveLang(lang.id); languagesPanel.hide()"
    >
      <ng-container
        *ngTemplateOutlet="flagImage; context: { $implicit: lang.id }"
      ></ng-container>
      <span class="ml-3">{{ lang.label }}</span>
    </button>
  </div>
</p-overlayPanel>

<!-- Flag image template -->
<ng-template let-lang #flagImage>
  <span class="relative w-6 shadow rounded-sm overflow-hidden">
    <span
      class="absolute inset-0 ring-1 ring-inset ring-black ring-opacity-10"
    ></span>
    <img
      class="w-full"
      [src]="'assets/images/flags/' + flagCodes[lang].toUpperCase() + '.svg'"
      [alt]="'Flag image for ' + lang"
    />
  </span>
</ng-template>
